import { useEffect, useState, type PropsWithChildren } from 'react';

import { initI18n, i18nInstance } from '@sshop/i18n';
import { isLocaleCode } from '@sshop/domain';

import { env } from '@/shared/config/env';
import { api } from '@/shared/lib/apiClient';
import { AppLoader } from '@/shared/ui/AppLoader';
import { resources } from './i18nResources';

const namespaces = [
  'common',
  'catalog',
  'product',
  'cart',
  'checkout',
  'auth',
  'account',
  'static',
] as const;

export function I18nProvider({ children }: PropsWithChildren<object>) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let active = true;
    const routeLocale = window.location.pathname.split('/')[1];
    const initialize = async () => {
      await initI18n({
        defaultLocale: isLocaleCode(routeLocale) ? routeLocale : env.DEFAULT_LOCALE,
        resources,
        namespaces,
      });
      try {
        const overrides = await api.translations.list();
        if (!active) return;
        for (const locale of ['ge', 'en'] as const) {
          for (const namespace of namespaces) {
            const entries = overrides[locale]?.[namespace];
            if (entries) i18nInstance.addResourceBundle(locale, namespace, entries, true, true);
          }
        }
      } catch {
        // Keep the bundled translations when the API is unavailable.
      }
      if (active) setReady(true);
    };
    void initialize();
    return () => {
      active = false;
    };
  }, []);

  if (!ready) {
    return <AppLoader />;
  }
  return <>{children}</>;
}
